export enum PointType {
  ADD = 'adding',
  REMOVE = 'removing',
}
